export const RECRUITING_CANDIDATE_READ = 'READ';
export const RECRUITING_CANDIDATE_UPDATE = 'UPDATE';

export const CANDIDATE_TRACKED_STATUSES = {
  KEEP_IN_VIEW: {
    label: 'Keep in view',
    currentFlag: 'isMarkedAsPotentialCandidate',
    initialFlag: 'initialIsMarkedAsPotentialCandidate',
  },

  BLACKLIST: {
    label: 'Blacklist',
    currentFlag: 'isInBlackList',
    initialFlag: 'initialIsInBlackList',
  },

  REFERRAL: {
    label: 'Referral',
    currentFlag: 'isReferral',
    initialFlag: 'initialIsReferral',
  },

  STUDENT: {
    label: 'Student',
    currentFlag: 'isStudent',
  },

  HIDDEN: {
    label: 'Hidden',
    currentFlag: 'isHidden',
  },
} as const;

export const STATUS_CHANGE_RULES = Object.values(CANDIDATE_TRACKED_STATUSES).filter(status => 'initialFlag' in status);
